import type { Guide, GuideRecordHint } from '../types';

/**
 * S-26.10-08 — zapytania klienta i dostępność aut dla zapytania (decyzja użytkownika 26.10.2026: CS jak
 * w makiecie; makieta CS-06; scenariusz e2e 37). A37Q — zapytanie „do sprawdzenia” z punktami
 * (`e2e/setup/scenario-state.mjs`). Nagrywarka tylko liczy dostępność i otwiera okna, niczego nie zapisuje.
 */
const INQUIRY: GuideRecordHint = {
  description: 'zapytanie „do sprawdzenia” — z listy zapytań',
  listPath: '/inquiries',
  listFilter: { status: 'to_check' },
};

export const guide: Guide = {
  flagKey: 'clientInquiries',
  title: 'Zapytania klienta i dostępność aut dla zapytania',
  whatItDoes:
    'CS zakłada zapytanie klienta — to ten sam rekord co prezlecenie, ale bez wiersza w banku i poza kolejkami. Na karcie zapytania „Sprawdź dostępność aut” liczy ten sam rachunek co rekomendacje pojazdów: ocenę, dolot, zapas, koszt, pominięte z powodem i konkurencję o pojazd. „Wskaż wstępnie” to znacznik CS — nie blokuje auta. Dalej: przekaż do FTL do decyzji, sygnał do Trade albo odmowa z powodem; potwierdzenie dla klienta to szkic, który wysyłasz sam i oznaczasz „Wysłane ręcznie”.',
  audience: ['CS', 'FTL', 'Trade'],
  presentationItems: ['S-26.10-08'],
  steps: [
    {
      route: '/inquiries',
      target: 'inquiry-list',
      title: 'Lista zapytań',
      description:
        'Zapytania ze stanem, wskazanym autem, przekazaniem do FTL i ostatnią wyceną. Filtry: otwarte, czekające na zatwierdzenie ceny, przekazane do FTL, sygnał do Trade. „Nowe zapytanie” — ten sam formularz co prezlecenie.',
      action: 'Otwórz „Zapytania” w menu.',
      recorder: { account: 'cs' },
    },
    {
      route: '/inquiries/:inquiryId/show',
      record: INQUIRY,
      target: 'inquiry-availability',
      title: 'Dostępność aut dla zapytania',
      description:
        'Ocena (mieści się, z zastrzeżeniem, brak danych, nie zdąży), wolny od i skąd, dolot, zapas, koszt dolotu i uwagi: zajętość, warianty innych zleceń, wskazanie w innym zapytaniu. Auta, które nie zdążą, nie da się wskazać. Pod tabelą pominięte z powodem.',
      action: 'Kliknij „Sprawdź dostępność aut”, potem „Wskaż wstępnie” przy wybranym aucie.',
      recorder: {
        account: 'cs',
        demo: { kind: 'scenario', key: 'a37InquiryId' },
        actions: [{ kind: 'click', target: 'inquiry-availability-run' }],
      },
    },
    {
      route: '/inquiries/:inquiryId/show',
      record: INQUIRY,
      target: 'inquiry-decision',
      title: 'Decyzja: FTL, Trade, odmowa, potwierdzenie',
      description:
        '„Przekaż do FTL do decyzji” — planista odpowiada: możliwe albo niemożliwe. „Sygnał: lepiej Trade”, „Odmów z powodem”. „Potwierdź klientowi” otwiera szkic: kopiuj albo otwórz w poczcie, wyślij sam i oznacz „Wysłane ręcznie”.',
      action: 'Kliknij „Potwierdź klientowi możliwość realizacji”, żeby zobaczyć szkic.',
      recorder: {
        account: 'cs',
        demo: { kind: 'scenario', key: 'a37InquiryId' },
        actions: [{ kind: 'click', target: 'inquiry-confirm-client' }],
      },
    },
  ],
};
